import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useCustomer } from "@/context/CustomerContext";

export function WishlistButton({ kind, item, className = "" }) {
  const { customer, setCustomer } = useCustomer();
  const navigate = useNavigate();
  const saved = (customer?.wishlist || []).some(
    (w) => w.kind === kind && w.item_id === item.id
  );

  const toggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!customer) {
      toast("Log in to save your favourites");
      navigate("/login");
      return;
    }
    try {
      if (saved) {
        const { data } = await api.delete(`/customer/wishlist/${kind}/${item.id}`);
        setCustomer(data);
      } else {
        const { data } = await api.post("/customer/wishlist", {
          kind,
          item_id: item.id,
          name: item.name,
          price: item.price || 0,
          image: item.image || "",
        });
        setCustomer(data);
        toast.success("Saved to favourites");
      }
    } catch {
      toast.error("Could not update favourites");
    }
  };

  return (
    <button
      type="button"
      data-testid={`wishlist-${kind}-${item.id}`}
      onClick={toggle}
      aria-label={saved ? "Remove from favourites" : "Save to favourites"}
      className={`h-9 w-9 grid place-items-center rounded-full bg-white/90 backdrop-blur border border-stone-200 shadow-sm hover:scale-105 transition-transform ${className}`}
    >
      <Heart className={`h-5 w-5 ${saved ? "fill-primary text-primary" : "text-stone-500"}`} />
    </button>
  );
}
